import { useState } from 'react';
import DemoBookingModal from './DemoBookingModal';

const PROFESSIONALS = [
  { id: 'valeria', name: 'Valeria Ramos',   role: 'Masajes & Relajación', emoji: '💆‍♀️', color: '#a855f7' },
  { id: 'martina', name: 'Martina López',   role: 'Estética facial',       emoji: '💅',    color: '#ec4899' },
  { id: 'lucas',   name: 'Lucas Fernández', role: 'Kinesiología',          emoji: '🧖‍♂️', color: '#3b82f6' },
];

const SERVICES = {
  valeria: [
    { id: 'masaje-relax', label: 'Masaje relajante',  dur: '45 min', price: '$8.500' },
    { id: 'masaje-dep',   label: 'Masaje deportivo',  dur: '60 min', price: '$11.000' },
    { id: 'drenaje',      label: 'Drenaje linfático', dur: '45 min', price: '$9.000' },
  ],
  martina: [
    { id: 'limpieza',  label: 'Limpieza facial',     dur: '45 min', price: '$7.500' },
    { id: 'hidra',     label: 'Hidratación profunda', dur: '30 min', price: '$5.500' },
    { id: 'antiedad',  label: 'Tratamiento antiedad', dur: '60 min', price: '$12.000' },
  ],
  lucas: [
    { id: 'kinesio',  label: 'Kinesiología deportiva', dur: '45 min', price: '$9.500' },
    { id: 'rehab',    label: 'Rehabilitación postural', dur: '60 min', price: '$11.500' },
    { id: 'masaje-t', label: 'Masaje terapéutico',      dur: '30 min', price: '$7.000' },
  ],
};

const SLOTS = [
  '09:00','09:45','10:30','11:15','12:00',
  '14:00','14:45','15:30','16:15','17:00','17:45','18:30',
];

const TAKEN = {
  valeria: {
    0: ['09:00','10:30','14:00','15:30','17:00'],
    1: ['09:45','11:15','14:45','16:15','18:30'],
    2: ['10:30','12:00','14:00','17:45'],
    3: ['09:00','10:30','15:30','17:00','18:30'],
    4: ['09:45','11:15','14:00','16:15'],
    5: ['10:30','12:00','14:45','17:00'],
    6: ['09:00','11:15','15:30','18:30'],
  },
  martina: {
    0: ['09:45','11:15','15:30','17:45'],
    1: ['09:00','12:00','14:00','16:15','18:30'],
    2: ['09:45','10:30','15:30','17:00'],
    3: ['11:15','14:45','16:15','18:30'],
    4: ['09:00','10:30','15:30','17:45'],
    5: ['09:45','12:00','14:00','17:00'],
    6: ['10:30','11:15','15:30','16:15'],
  },
  lucas: {
    0: ['10:30','14:45','17:45'],
    1: ['09:00','11:15','16:15'],
    2: ['09:45','14:00','17:00','18:30'],
    3: ['10:30','12:00','15:30'],
    4: ['09:00','14:45','17:45'],
    5: ['11:15','15:30','18:30'],
    6: ['10:30','14:00','16:15'],
  },
};

const STATS = [
  { label: 'Turnos este mes',         value: '134' },
  { label: 'Profesional más ocupada', value: 'Valeria' },
  { label: 'Horario pico',            value: '10:30' },
];

const DAY_NAMES   = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];
const MONTH_NAMES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

function getWeekDays(base) {
  const start = new Date(base);
  start.setDate(start.getDate() - (start.getDay() === 0 ? 6 : start.getDay() - 1));
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(start); d.setDate(start.getDate() + i); return d;
  });
}
function isSameDay(a, b) {
  return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
}

export default function LuminaDemo() {
  const today = new Date();
  const [selectedProf, setSelectedProf] = useState('valeria');
  const [selectedDate, setSelectedDate] = useState(today);
  const [weekBase,     setWeekBase]     = useState(today);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedSvc,  setSelectedSvc]  = useState(null);
  const [modalOpen,    setModalOpen]    = useState(false);

  const weekDays  = getWeekDays(weekBase);
  const dayIndex  = selectedDate.getDay() === 0 ? 6 : selectedDate.getDay() - 1;
  const takenToday = TAKEN[selectedProf][dayIndex] || [];
  const prof       = PROFESSIONALS.find(p => p.id === selectedProf);
  const services   = SERVICES[selectedProf];
  const freeCount  = SLOTS.length - takenToday.length;

  function selectSlot(slot) {
    setSelectedSlot(slot);
    setSelectedSvc(null);
  }

  const bookingLabel = selectedSlot && selectedSvc
    ? `${prof.emoji} ${prof.name} · ${selectedSvc.label} · ${selectedSlot} hs`
    : '';

  return (
    <div style={{ maxWidth: 860, margin: '0 auto', padding: '24px 16px', fontFamily: 'var(--font-body)' }}>

      {/* HEADER */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 18,
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)', padding: '24px 28px', marginBottom: 20,
        boxShadow: 'var(--shadow)',
      }}>
        <div style={{
          width: 60, height: 60, borderRadius: 'var(--r-lg)',
          background: 'linear-gradient(135deg,#a855f720,#ec489920)',
          border: '1px solid #a855f740',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, flexShrink: 0,
        }}>🌿</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: 'var(--font-head)', fontSize: '1.4rem', fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '-0.03em' }}>
            Lumina Wellness
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 3 }}>
            Centro de estética y bienestar · Palermo, Buenos Aires
          </div>
        </div>
        <div style={{
          background: 'linear-gradient(135deg,#a855f715,#ec489915)',
          border: '1px solid #a855f730',
          borderRadius: 'var(--r-full)', padding: '4px 14px',
          fontSize: 11, fontWeight: 700, color: '#a855f7', letterSpacing: '.06em',
        }}>
          PLAN PROFESIONAL
        </div>
      </div>

      {/* STATS */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 12, marginBottom: 20 }}>
        {STATS.map(({ label, value }) => (
          <div key={label} style={{
            background: 'var(--surface)', border: '1px solid var(--border)',
            borderRadius: 'var(--r-lg)', padding: '16px 18px', boxShadow: 'var(--shadow)',
          }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.08em', color: 'var(--text-muted)', marginBottom: 6 }}>
              {label.toUpperCase()}
            </div>
            <div style={{ fontFamily: 'var(--font-head)', fontSize: '1.6rem', fontWeight: 800, color: 'var(--green-light)', letterSpacing: '-0.04em' }}>
              {value}
            </div>
          </div>
        ))}
      </div>

      {/* SELECTOR DE PROFESIONAL */}
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)', padding: '20px 24px', marginBottom: 16,
        boxShadow: 'var(--shadow)',
      }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', color: 'var(--text-muted)', marginBottom: 14 }}>
          ELEGÍ UN PROFESIONAL
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10 }}>
          {PROFESSIONALS.map(p => {
            const isSel = selectedProf === p.id;
            return (
              <button key={p.id}
                onClick={() => { setSelectedProf(p.id); setSelectedSlot(null); setSelectedSvc(null); }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
                  padding: '14px 10px', borderRadius: 'var(--r-md)',
                  border: isSel ? `2px solid ${p.color}` : '1px solid var(--border)',
                  background: isSel ? `${p.color}12` : 'transparent',
                  cursor: 'pointer', transition: 'all .18s', textAlign: 'center',
                }}
              >
                <div style={{
                  width: 44, height: 44, borderRadius: '50%',
                  background: `${p.color}20`, border: `2px solid ${isSel ? p.color : 'transparent'}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
                }}>
                  {p.emoji}
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: '0.82rem', color: isSel ? p.color : 'var(--text-primary)' }}>
                    {p.name.split(' ')[0]}
                  </div>
                  <div style={{ fontSize: 10.5, color: 'var(--text-muted)', marginTop: 2 }}>{p.role}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* SELECTOR DE SEMANA */}
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)', padding: '18px 22px', marginBottom: 16,
        boxShadow: 'var(--shadow)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <button onClick={() => { const d = new Date(weekBase); d.setDate(d.getDate()-7); setWeekBase(d); }} style={navBtnStyle}>
            ← Anterior
          </button>
          <span style={{ fontFamily: 'var(--font-head)', fontWeight: 700, color: 'var(--text-primary)', fontSize: '0.93rem' }}>
            {MONTH_NAMES[weekDays[0].getMonth()]} {weekDays[0].getFullYear()}
          </span>
          <button onClick={() => { const d = new Date(weekBase); d.setDate(d.getDate()+7); setWeekBase(d); }} style={navBtnStyle}>
            Siguiente →
          </button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 8 }}>
          {weekDays.map((d, i) => {
            const isToday = isSameDay(d, today);
            const isSel   = isSameDay(d, selectedDate);
            return (
              <button key={i}
                onClick={() => { setSelectedDate(d); setSelectedSlot(null); setSelectedSvc(null); }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                  padding: '10px 4px', borderRadius: 'var(--r-md)',
                  border: isSel ? '2px solid var(--green)' : '1px solid var(--border)',
                  background: isSel ? 'var(--green-bg)' : isToday ? 'var(--bg3)' : 'transparent',
                  cursor: 'pointer', transition: 'all .18s',
                }}
              >
                <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, letterSpacing: '.06em' }}>
                  {DAY_NAMES[i]}
                </span>
                <span style={{ fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: '1.1rem', color: isSel ? 'var(--green-light)' : 'var(--text-primary)' }}>
                  {d.getDate()}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* INFO BAR */}
      <div style={{ marginBottom: 14, display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{
          display: 'flex', alignItems: 'center', gap: 6,
          background: `${prof.color}15`, border: `1px solid ${prof.color}40`,
          borderRadius: 'var(--r-full)', padding: '4px 12px',
          fontSize: 12.5, fontWeight: 700, color: prof.color,
        }}>
          {prof.emoji} {prof.name}
        </span>
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          {freeCount} turnos disponibles · {DAY_NAMES[dayIndex]} {selectedDate.getDate()} de {MONTH_NAMES[selectedDate.getMonth()]}
        </span>
      </div>

      {/* GRILLA DE SLOTS */}
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)', padding: '24px', boxShadow: 'var(--shadow)',
        marginBottom: selectedSlot ? 16 : 0,
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 9 }}>
          {SLOTS.map(slot => {
            const taken = takenToday.includes(slot);
            const isSel = selectedSlot === slot;
            return (
              <button key={slot}
                onClick={() => !taken && selectSlot(isSel ? null : slot)}
                disabled={taken}
                style={{
                  padding: '12px 0', borderRadius: 'var(--r-md)', textAlign: 'center',
                  border: isSel ? `2px solid ${prof.color}` : '1px solid var(--border)',
                  background: isSel ? `${prof.color}15` : 'transparent',
                  color: isSel ? prof.color : taken ? 'var(--text-muted)' : 'var(--text-primary)',
                  fontFamily: 'var(--font-head)', fontWeight: isSel ? 700 : taken ? 400 : 600,
                  fontSize: '0.9rem', cursor: taken ? 'not-allowed' : 'pointer',
                  opacity: taken ? 0.35 : 1, transition: 'all .15s',
                  textDecoration: taken ? 'line-through' : 'none',
                }}
              >
                {slot}
              </button>
            );
          })}
        </div>
      </div>

      {/* SELECTOR DE SERVICIO — aparece al elegir horario */}
      {selectedSlot && (
        <div style={{
          background: 'var(--surface)', border: `1px solid ${prof.color}40`,
          borderRadius: 'var(--r-xl)', padding: '20px 24px', boxShadow: 'var(--shadow)',
          animation: 'fadeIn .2s ease',
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', color: 'var(--text-muted)', marginBottom: 12 }}>
            ELEGÍ UN SERVICIO — {selectedSlot} hs
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
            {services.map(svc => {
              const isSel = selectedSvc?.id === svc.id;
              return (
                <button key={svc.id}
                  onClick={() => setSelectedSvc(isSel ? null : svc)}
                  style={{
                    padding: '14px 12px', borderRadius: 'var(--r-md)', textAlign: 'left',
                    border: isSel ? `2px solid ${prof.color}` : '1px solid var(--border)',
                    background: isSel ? `${prof.color}12` : 'var(--bg3)',
                    cursor: 'pointer', transition: 'all .15s',
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: 13, color: isSel ? prof.color : 'var(--text-primary)', marginBottom: 4 }}>
                    {svc.label}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                    {svc.dur} · {svc.price}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* BARRA DE CONFIRMACIÓN — aparece al elegir horario + servicio */}
      {selectedSlot && selectedSvc && (
        <div style={{
          position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
          background: 'var(--surface)', border: `1px solid ${prof.color}`,
          borderRadius: 'var(--r-xl)', padding: '16px 28px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
          display: 'flex', alignItems: 'center', gap: 20, zIndex: 200,
        }}>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Tu turno</div>
            <div style={{ fontFamily: 'var(--font-head)', fontWeight: 700, color: 'var(--text-primary)', fontSize: '0.93rem' }}>
              {prof.emoji} {prof.name} · {selectedSvc.label} · {selectedSlot} hs
            </div>
          </div>
          <button
            onClick={() => setModalOpen(true)}
            style={{
              background: prof.color, color: '#fff', border: 'none',
              padding: '10px 24px', borderRadius: 'var(--r-full)',
              fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
            }}
          >
            Reservar turno
          </button>
          <button
            onClick={() => { setSelectedSlot(null); setSelectedSvc(null); }}
            style={{
              background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text-muted)', borderRadius: 'var(--r-full)',
              padding: '9px 16px', cursor: 'pointer', fontSize: '0.85rem',
            }}
          >
            Cancelar
          </button>
        </div>
      )}

      <DemoBookingModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        booking={bookingLabel}
      />

      <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}

const navBtnStyle = {
  background: 'transparent', border: '1px solid var(--border)',
  color: 'var(--text-secondary)', borderRadius: 'var(--r-full)',
  padding: '6px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 500,
};
